import { render, staticRenderFns } from "./Organism3DModelInteraction.vue?vue&type=template&id=8c711110&"
import script from "./Organism3DModelInteraction.vue?vue&type=script&lang=js&"
export * from "./Organism3DModelInteraction.vue?vue&type=script&lang=js&"
import style0 from "./Organism3DModelInteraction.vue?vue&type=style&index=0&id=8c711110&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
